import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["messages", "input", "form", "submitButton"];
  static values = {
    conversationId: Number
  };

  connect() {
    this.scrollToBottom();
  }

  handleSubmit(event) {
    if (event.detail.success) {
      // Clear input after successful submission
      this.inputTarget.value = "";
      this.inputTarget.style.height = "auto";
      
      // Scroll to bottom to show new message
      setTimeout(() => this.scrollToBottom(), 100);
    }
  }

  handleKeydown(event) {
    // Submit on Enter (without Shift)
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.formTarget.requestSubmit();
    }
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
    }
  }
}

